// Home.js
import React from 'react';
import HeroSlider from '../components/HeroSlider';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Gallery from '../components/Gallery';
import SectionDivider from '../components/SectionDivider';

function Home() {
  return (
    <div className="App">
      <HeroSlider />
      <About />
      <SectionDivider 
        imageUrl="/assets/NCC_QWred.png"
        altText="Red wood ring divider"
      />
      <Gallery />
      <SectionDivider 
        imageUrl="/assets/NCC_Trees.png"
        altText="Trees silhouette divider"
      />
      <Contact />
    </div>
  );
}

export default Home;
